module.exports = __webpack_public_path__ + "static/media/shipPicThree.cb674a54.jpeg";